<template>
    <div class="con">

        <Card>
            <div class="scan-station">
                <div class="title-scan">Scan complete</div>
                <div class="img-container">
                    <img src="../assets/CircleWavyCheck.png">
                </div>
                <p>Choose battery box on station screen to change a new batteries</p>
                <span @click="routeTo('Station')">
                    <Button class="next-btn">Next Step</Button>
                </span>
            </div>

        </Card>

    </div>
</template>
  
<script>
import Button from "../components/Button.vue"
import Card from "../components/Card.vue"

export default {
    name: "Scan",
    props: ['selectedBattery'],
    components: {
        Button,
        Card
    },
    data() {
        return {
            stationId: '',
        }
    },
    methods: {
        routeTo(route) {
            if (!route) return
            // console.log(route)
            this.$router.push({ name: route, query: { station: this.stationId } })
        }
    },
    created() {
        this.stationId = this.$route.query.station;
        // console.log(this.stationId)
    },
}
</script>
  
<style scoped>
.con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.scan-station {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 325px;
    height: 373px;
    padding: 24px;
}

.title-scan {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 30px;
}

.img-container {
    width: 78px;
    height: 78px;
}

p {
    text-align: center;
    position: relative;
    font-size: 14px;
    color: var(--theme-one);
    margin-top: 16px;
}

.next-btn {
    width: 155px !important;
    height: 56px !important;
    color: #fff;
    margin-top: 30px;
}

/* .title-scan {
    font-size: var(--font-m-large);
    font-weight: 700;
}

.img-container {
    display: flex;
    align-items: center;
    justify-items: center;
    height: 150px;
}

.next-button {
    border-radius: 8px;
    min-height: 56px;
    min-width: 155px !important;
    color: var(--theme-four);
}

p {
    text-align: center;
    position: relative;
    font-size: var(--font-mini);
    color: var(--theme-one);
} */
</style>